import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


export default function BasicSelect(props) {
  let { 
    slug,
    label,
    items,
    displayEmptyValue = true,
    autoTrad,
    disabled = false,
    placeholder = null,
    icon = null
  } = props;

  const { t: gctrad } = useTranslation();

  const handleChange = (event) => {
    props.parentFunction(event.target.value, slug);
  };

  return (
    <ThemeProvider theme={backYouTheme}>
        <Select
          size="small"
          className="d-block w-100 bg-white"
          id={"basic-select-" + slug}
          value={props.selectedItems ?? ''}
          onChange={handleChange}
          style={{ borderRadius: '0.38rem' }}
          displayEmpty
          disabled={disabled}
          startAdornment={icon && (
            <InputAdornment position="start">
              <i className={icon}></i>
            </InputAdornment>
          )}
          // IconComponent={() => null}
          IconComponent={ArrowDropDownIcon} // Ajoute une icône de flèche
        >
          {displayEmptyValue && (
            <MenuItem value="">
              <em className="text-muted">{placeholder ? placeholder : gctrad('[:myspace] Aucune sélection')}</em>
            </MenuItem>
          )}
          
          {items.map((e, i) => (
            <MenuItem key={i} value={e.value}>
              {autoTrad ? (e.label).trad() : gctrad(e.label)}
            </MenuItem>
          ))}
        </Select>
    </ThemeProvider>
  );
}